// Shared types for the revamped Exam module (question paper + answer paper).

export type ExamLanguage = 'english' | 'traditional_chinese' | 'simplified_chinese' | 'auto';

export interface McqQuestion {
  question: string;
  options: string[];
  answer_index: number;
  explanation?: string;
}

export interface TfQuestion {
  question: string;
  answer: boolean;
  explanation?: string;
}

export interface MatchingGroup {
  instruction?: string;
  items: { key: string; left: string }[];
  options: string[];
  pairs: { key: string; answer_index: number }[];
}

export interface ShortQuestion {
  question: string;
  answer: string;
  points?: string;
  marks: number;
}

export interface ExamPaperQuestions {
  mcq: McqQuestion[];
  tf: TfQuestion[];
  matching: MatchingGroup[];
  short: ShortQuestion[];
}

export interface ExamPaper {
  title: string;
  language: string;
  questions: ExamPaperQuestions;
  pages_read?: number;
  total_pages?: number;
  truncated?: boolean;
  method?: string;
  source_word_count?: number;
}

export const SECTION_LABELS: Record<keyof ExamPaperQuestions, string> = {
  mcq: 'Multiple Choice',
  tf: 'True / False',
  matching: 'Matching',
  short: 'Short Questions',
};

export function paperTotalMarks(paper: ExamPaperQuestions): number {
  let marks = paper.mcq.length + paper.tf.length;
  paper.matching.forEach((g) => (marks += g.items.length));
  paper.short.forEach((q) => (marks += q.marks || 0));
  return marks;
}

export function paperQuestionCount(paper: ExamPaperQuestions): number {
  return (
    paper.mcq.length +
    paper.tf.length +
    paper.matching.reduce((acc, g) => acc + g.items.length, 0) +
    paper.short.length
  );
}

export function safeFileName(title: string): string {
  return (title || 'exam').replace(/[^a-z0-9-_]+/gi, '_').replace(/^_+|_+$/g, '').slice(0, 60) || 'exam';
}
